import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getActivity = async (activityId) => {
    const { data } = await vlqrApi.get(`Activities/${activityId}`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useBasicActivity = (activityId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['basicActivity', activityId],
        queryFn: () => getActivity(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useBasicActivity;